import { bootstrapPortal } from "@/shared/app/bootstrapPortal";
import VendorApp from "./App.vendor";

bootstrapPortal("vendor", <VendorApp />);
